import {
  //
  FETCH_LOCATION_INCIDENT_RECORDS,
  FETCH_LOCATION_INCIDENT_RECORDS_SUCCESS,
  FETCH_LOCATION_INCIDENT_RECORDS_FAILURE,
  //
  FETCH_RESIDENT_INCIDENT_RECORDS,
  FETCH_RESIDENT_INCIDENT_RECORDS_SUCCESS,
  FETCH_RESIDENT_INCIDENT_RECORDS_FAILURE,
  //
  FETCH_INCIDENT_RECORD,
  FETCH_INCIDENT_RECORD_SUCCESS,
  FETCH_INCIDENT_RECORD_FAILURE,
  //
  CREATE_INCIDENT_RECORD,
  CREATE_INCIDENT_RECORD_SUCCESS,
  CREATE_INCIDENT_RECORD_FAILURE,
  //
  UPDATE_INCIDENT_RECORD,
  UPDATE_INCIDENT_RECORD_SUCCESS,
  UPDATE_INCIDENT_RECORD_FAILURE,
  //
  ADD_INCIDENT_NOTIFICATION,
  ADD_INCIDENT_NOTIFICATION_SUCCESS,
  ADD_INCIDENT_NOTIFICATION_FAILURE,
  //
  ESCALATE_INCIDENT_SAFEGUARDING,
  ESCALATE_INCIDENT_SAFEGUARDING_SUCCESS,
  ESCALATE_INCIDENT_SAFEGUARDING_FAILURE,
  //
  CLOSE_INCIDENT_RECORD,
  CLOSE_INCIDENT_RECORD_SUCCESS,
  CLOSE_INCIDENT_RECORD_FAILURE,
  //
  REOPEN_INCIDENT_RECORD,
  REOPEN_INCIDENT_RECORD_SUCCESS,
  REOPEN_INCIDENT_RECORD_FAILURE,
} from "./constants";

// List the location register — payload: { locationId, filters, page, perPage }
export const fetchLocationIncidentRecords = (payload, onSuccess) => ({
  type: FETCH_LOCATION_INCIDENT_RECORDS,
  payload,
  onSuccess,
});
export const fetchLocationIncidentRecordsSuccess = (payload) => ({
  type: FETCH_LOCATION_INCIDENT_RECORDS_SUCCESS,
  payload,
});
export const fetchLocationIncidentRecordsFailure = (payload) => ({
  type: FETCH_LOCATION_INCIDENT_RECORDS_FAILURE,
  payload,
});

// List a resident's records for the workspace panel — arg: residentId
export const fetchResidentIncidentRecords = (residentId, onSuccess) => ({
  type: FETCH_RESIDENT_INCIDENT_RECORDS,
  payload: { residentId },
  onSuccess,
});
export const fetchResidentIncidentRecordsSuccess = (payload) => ({
  type: FETCH_RESIDENT_INCIDENT_RECORDS_SUCCESS,
  payload,
});
export const fetchResidentIncidentRecordsFailure = (payload) => ({
  type: FETCH_RESIDENT_INCIDENT_RECORDS_FAILURE,
  payload,
});

// Get one record — payload: { residentId, uuid }
export const fetchIncidentRecord = (payload, onSuccess) => ({
  type: FETCH_INCIDENT_RECORD,
  payload,
  onSuccess,
});
export const fetchIncidentRecordSuccess = (payload) => ({
  type: FETCH_INCIDENT_RECORD_SUCCESS,
  payload,
});
export const fetchIncidentRecordFailure = (payload) => ({
  type: FETCH_INCIDENT_RECORD_FAILURE,
  payload,
});

// Create (manual entry) — payload: { residentId, data }
export const createIncidentRecord = (payload, onSuccess, onError) => ({
  type: CREATE_INCIDENT_RECORD,
  payload,
  onSuccess,
  onError,
});
export const createIncidentRecordSuccess = (payload) => ({
  type: CREATE_INCIDENT_RECORD_SUCCESS,
  payload,
});
export const createIncidentRecordFailure = (payload) => ({
  type: CREATE_INCIDENT_RECORD_FAILURE,
  payload,
});

// Update a step — payload: { residentId, uuid, data }
export const updateIncidentRecord = (payload, onSuccess, onError) => ({
  type: UPDATE_INCIDENT_RECORD,
  payload,
  onSuccess,
  onError,
});
export const updateIncidentRecordSuccess = (payload) => ({
  type: UPDATE_INCIDENT_RECORD_SUCCESS,
  payload,
});
export const updateIncidentRecordFailure = (payload) => ({
  type: UPDATE_INCIDENT_RECORD_FAILURE,
  payload,
});

// Add a statutory notification — payload: { residentId, uuid, data }
export const addIncidentNotification = (payload, onSuccess) => ({
  type: ADD_INCIDENT_NOTIFICATION,
  payload,
  onSuccess,
});
export const addIncidentNotificationSuccess = (payload) => ({
  type: ADD_INCIDENT_NOTIFICATION_SUCCESS,
  payload,
});
export const addIncidentNotificationFailure = (payload) => ({
  type: ADD_INCIDENT_NOTIFICATION_FAILURE,
  payload,
});

// Escalate to safeguarding — payload: { residentId, uuid, safeguardingReviewId? }
export const escalateIncidentSafeguarding = (payload, onSuccess) => ({
  type: ESCALATE_INCIDENT_SAFEGUARDING,
  payload,
  onSuccess,
});
export const escalateIncidentSafeguardingSuccess = (payload) => ({
  type: ESCALATE_INCIDENT_SAFEGUARDING_SUCCESS,
  payload,
});
export const escalateIncidentSafeguardingFailure = (payload) => ({
  type: ESCALATE_INCIDENT_SAFEGUARDING_FAILURE,
  payload,
});

// Close — payload: { residentId, uuid, data }. onGateBlocked(body) fires on the
// HTTP 422 notification / candour gate instead of the generic error toast.
export const closeIncidentRecord = (payload, onSuccess, onGateBlocked) => ({
  type: CLOSE_INCIDENT_RECORD,
  payload,
  onSuccess,
  onGateBlocked,
});
export const closeIncidentRecordSuccess = (payload) => ({
  type: CLOSE_INCIDENT_RECORD_SUCCESS,
  payload,
});
export const closeIncidentRecordFailure = (payload) => ({
  type: CLOSE_INCIDENT_RECORD_FAILURE,
  payload,
});

// Reopen — payload: { residentId, uuid }
export const reopenIncidentRecord = (payload, onSuccess) => ({
  type: REOPEN_INCIDENT_RECORD,
  payload,
  onSuccess,
});
export const reopenIncidentRecordSuccess = (payload) => ({
  type: REOPEN_INCIDENT_RECORD_SUCCESS,
  payload,
});
export const reopenIncidentRecordFailure = (payload) => ({
  type: REOPEN_INCIDENT_RECORD_FAILURE,
  payload,
});
